import React, {useState, useRef, useEffect} from 'react';
import {connect} from 'react-redux';
import {
  setInputsList,
  setParamToDisplay,
  validateSelectedAccount,
  resetDisabledParams,
  isExternalCompanyNumber,
  validateSimCardNumber,
  getExtendedParamData,
} from '../../BusinessWorkOrderSystemSlice';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import TextArea from 'app/Components/Shared/TextArea/TextArea';
import {GenericInputType, GenericInputTypeDef, ParamsNeedingExtendedData, errorMessages, SUBNAME_PARAM_CODE} from '../../Constant/Constant';
import {validateInput, TextInputEnum} from '../../../../../utilities/validation/InputValidation';
import DatePicker from 'app/Components/Shared/DatePicker/DatePicker';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';
import RadioInput from 'app/Components/Shared/RadioInput/RadioInput';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import TextInputWithButton from 'app/Components/Shared/TextInputWithButton/TextInputWithButton';
import AddressForm from 'app/Components/Block/SaleJetBlock/Partials/AddressForm/AddressForm';
import EpiContext from '@episerver/spa-core/Spa';
import PricePlanRadioInput from './PricePlanRadioInput';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import {validateOtpDataFamilyWithChildrenRequest} from 'app/Components/Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {innerPopupTypes} from 'app/Components/Block/CouponComponentBlock/CouponComponentEnums';
import { getBansForOrg } from '../../../BusinessReportBlock/BusinessReportBlockSlice';

const GenericInput = ({
  input,
  businessWorkOrderSystem,
  setInputsList,
  setParamToDisplay,
  selectedHetPay,
  orgId,
  validateSelectedAccount,
  isExternalCompanyNumber,
  validateSimCardNumber,
  isSubmit,
  iContentRepo,
  getExtendedParamData,
  resetDisabledParams,
  contentData,
  showSubscriberFullName,
  orgBanList,
  getBansForOrg
}) => {
  const inputRef = useRef(null);
  const [fullName, setFullName] = useState(null);
  const displayParamDesc = input.isRequired ? (
    <>
      {input.paramDesc}&nbsp;<span style={{color: '#9631ff'}}> *</span>
    </>
  ) : (
    input.paramDesc
  );

  const [fetchExtendedParamData, setFetchExtendedParamData] = useState(false);

  const needToFetchExtendedData = ParamsNeedingExtendedData.includes(input.paramTypeDefinition.paramType) && !input.getExtendedData;

  const updateSubnameValue = (value) => {
    if (businessWorkOrderSystem.workOrderParams[SUBNAME_PARAM_CODE]) {
      setInputsList({paramcode: SUBNAME_PARAM_CODE, value: value ?? '', error: ''});
    }
  };

  const handleInputChange = async (inputValue) => {
    var type = GenericInputTypeDef[input.paramTypeDefinition.paramType]?.inputValidationType ?? TextInputEnum.None;
    var error = input.dropdownOptions ? '' : validateInput(inputValue, type, input.isRequired);
    setFullName(null);
    setInputsList({paramcode: input.paramCode, value: inputValue, error: error, validated: false});
    if (input.paramTypeDefinition.paramType === GenericInputType.Subscriber) {
      updateSubnameValue('');
    }
    if (input.paramTypeDefinition.paramType == GenericInputType.BAN) {
      await getDependedParamData(inputValue.key);
    }
    resetDisabledParams();
  };

  const onDropdownChange = (e) => {
    var arrDepedendyParamCode = input.dropdownOptions.filter((option) => option.dependency != null).map((d) => d.dependency);
    arrDepedendyParamCode.forEach((paramCode) => {
      if (businessWorkOrderSystem.workOrderParams[paramCode]?.display) {
        setParamToDisplay({paramCode, display: false});
      }
    });
    if (e.dependency != null) {
      setParamToDisplay({paramCode: e.dependency, display: true});
    }
    handleInputChange(e);
  };

  const requiresAdditionalValidation = async () => {
    var res;
    if (GenericInputTypeDef[input.paramTypeDefinition.paramType]?.requiresAdditionalValidation) {
      setInputsList({...input, isLoading: true});
      switch (input.paramTypeDefinition.paramType) {
        case GenericInputType.Subscriber:
          res = await validateSelectedAccount({subscriber: input.value, orgId: orgId, paramCode: input.paramCode});
          if (res.payload.isAllowed) {
            await getDependedParamData(input.value);
            if (showSubscriberFullName) {
              const fullName = `${res.payload?.firstName ?? ''} ${res.payload?.lastName ?? ''}`.trim();
              if (!isNullOrEmpty(fullName)) {
                setFullName(fullName);
                updateSubnameValue(fullName);
              }
            }
          }
          break;
        case GenericInputType.SubNiud:
          res = await isExternalCompanyNumber({phoneNumber: input.value});
          break;
        case GenericInputType.Sim:
          res = await validateSimCardNumber(input.value);
          break;
      }
    }
    if (res.payload.isSuccess) {
      resetDisabledParams();
      setInputsList({...input, validated: true, error: '', isLoading: false});
    } else {
      if (res.payload.error) {
        setInputsList({...input, error: res.payload.error, isLoading: false});
      }
    }
  };

  const getDependedParamData = async (paramValue) => {
    const dependedParam = Object.values(businessWorkOrderSystem.workOrderParams).find(
      (p) => p.paramDependenCode === input.paramCode && ParamsNeedingExtendedData.includes(p.paramTypeDefinition?.paramType),
    );

    if (dependedParam) {
      var block = Object.values(iContentRepo).find((p) => p.path.includes(window.location.pathname));
      var blockId = block?.content?.mainContentArea?.value[0]?.contentLink?.id;

      var res = await getExtendedParamData({
        paramCode: dependedParam.paramCode,
        paramType: dependedParam.paramTypeDefinition.paramType,
        orgId: selectedHetPay,
        blockId: blockId,
        dependedParamValue: paramValue,
        dependedGroupType: input.paramTypeDefinition.paramType,
      });
    }
  };

  const getDependendDate = () => {
    if (input.paramDependenCode && businessWorkOrderSystem.workOrderParams[input.paramDependenCode]?.type == GenericInputType.DateTime) {
      return businessWorkOrderSystem.workOrderParams[input.paramDependenCode]?.value;
    }
  };

  const getCommonInputProps = () => ({
    value: input.value,
    id: input.paramCode,
    placeholder: input.paramDesc,
    ref: inputRef,
    required: input.isRequired,
    maxLength: input.paramTypeDefinition.paramLength ? parseInt(input.paramTypeDefinition.paramLength) : undefined,
  });

  const getClientNameByBan = (ban) => {
    if (!orgBanList || !ban) return '';

    const match = orgBanList.find(item => item.banId == ban);

    return match?.fullName || '';
  };

  const getOptionText = (option) => {
    if (input.paramTypeDefinition.paramType == GenericInputType.BAN) {
      return `${option.key} - ${option.value}`
    }

    return option.value;
  };

  const generateInputFieldByType = () => {
    switch (input.paramTypeDefinition.paramType) {
      case GenericInputType.String:
      case GenericInputType.Number:
      case GenericInputType.IDNumber:
      case GenericInputType.None:
        return (
          <TextInput
            {...getCommonInputProps()}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
          />
        );

      case GenericInputType.Subscriber:
      case GenericInputType.SubNiud:
      case GenericInputType.Sim:
        return (
          <TextInputWithButton
            {...getCommonInputProps()}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
            disabled={input.isLoading}
            btnDisabled={isNullOrEmpty(input.value) || (!isNullOrEmpty(input.error) && input.error != errorMessages.anotherValidation)}
            buttonAction={() => requiresAdditionalValidation()}
            isLoading={input.isLoading}
            isValidated={input.validated && !input.isLoading}
            fullName={fullName}
          />
        );

      case GenericInputType.DateTime:
        return (
          <label className='has-float-label-required'>
            <DatePicker
              ref={inputRef}
              dependedDate={getDependendDate()}
              inputWidth={'100%'}
              inputHeight={'52px'}
              selectedDate={input.value}
              numOfYearsBack={contentData?.numOfYearsBack.value}
              setSelectedDate={(date) => handleInputChange(date)}
            />
            <span className='float-label'>{input.paramDesc}</span>
          </label>
        );
      case GenericInputType.TextArea:
        return (
          <TextArea
            {...getCommonInputProps()}
            onChange={(value) => {
              handleInputChange(value);
            }}
          />
        );
      case GenericInputType.RadioButton:
        return (
          <div className='radio-input-container'>
            <div className='title'>{displayParamDesc}</div>
            {input.dropdownOptions?.map((option, index) => (
              <RadioInput
                key={option.option_key}
                checked={input.value === option.option_value}
                id={option.option_key}
                name={input.paramCode}
                value={option.option_value}
                label={option.option_value}
                onChange={() => {
                  setInputsList({paramcode: input.paramCode, value: option.option_value, error: ''});
                }}
              />
            ))}
          </div>
        );

      case GenericInputType.Address:
        return (
          <AddressForm
            isRequired={input.isRequired}
            isSubmit={isSubmit}
            onSubmit={(res) => setInputsList({paramcode: input.paramCode, value: res, error: ''})}
            selectedAddress={{
              cityName: input.value?.cityName ?? '',
              streetName: input.value?.streetName ?? '',
              home: input.value?.home ?? '',
              apartment: input.value?.apartment ?? '',
              zipCode: input.value?.zipCode ?? '',
              floor: input.value?.floor ?? '',
            }}
          />
        );

      case GenericInputType.PricePlan:
        return <PricePlanRadioInput input={input} setInputsList={setInputsList} isLoading={input.isLoading} paramDesc={displayParamDesc} />;

      case GenericInputType.CheckBox:
        return (
          <CheckBox
            checked={input.value}
            label={displayParamDesc}
            id={input.paramCode}
            onCheck={() => setInputsList({paramcode: input.paramCode, value: true})}
            onUncheck={() => setInputsList({paramcode: input.paramCode, value: false})}
          />
        );

      default:
        if (input.dropdownOptions != null) {
          return (
            <ReactSelect
              getOptionLabel={(option) => getOptionText(option)}
              getOptionValue={(option) => option.value}
              placeholder={displayParamDesc}
              options={input.dropdownOptions?.map((option) => ({
                key: option.option_key,
                value: option.option_value,
                dependency: option.dependency,
              }))}
              onChange={(e) => {
                onDropdownChange(e);
              }}
              value={
                input.value
                  ? {
                      key: input.value.key,
                      value: (
                        <>
                          {`${input.paramDesc} : `}
                          <b>{input.value.value}</b>
                        </>
                      ),
                    }
                  : null
              }
            />
          );
        }
    }
  };

  return (
    <div
      className={`generic-input-container ${input.disabled ? 'disabled' : ''}
                                             ${input.isRequired ? 'required' : ''}
                                             ${!isNullOrEmpty(input.error) ? 'focus-input-error' : ''}`}>
      {(!needToFetchExtendedData || input.isLoading) && (
        <>
          {generateInputFieldByType()}
          {input.error && !input.disabled && <div className='generic-input-error'>{input.error}</div>}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  orgId: state.portalsBlock.selectedHetPayId,
  iContentRepo: state.iContentRepo.items,
  orgBanList: state.businessReport.orgBanList,
});

const mapDispatchToProps = {
  setInputsList,
  setParamToDisplay,
  validateSelectedAccount,
  resetDisabledParams,
  isExternalCompanyNumber,
  validateSimCardNumber,
  getExtendedParamData,
  getBansForOrg
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericInput);
